import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper } from "./styled";
import MainLayout from "../../commons/MainLayout";
import Table from "./components/Table";
import Header from "./components/Header";
import Buttons from "./components/Buttons";
import BackButton from "./components/BackButton";
import { selectedArticles } from "../../../store/Concept/selectors";
import { calTotal, loadCaptcha } from "../../../store/Concept/actions";
import { isChecked } from "../../../utils/functions";
import { useHistory } from "react-router-dom";
import { PATH_FORM } from "../App/constants";
import { getContribData } from "../StartForm/components/Form/components/ContributorForm/components/ContributorInputs/constants";
import { getPayerData } from "../StartForm/components/Form/components/PayerForm/components/PayerInputs/constants";
import { contributorData, taxPayerData } from "../../../store/Users/selectors";

const GeneratePaymentRequest = ({ detail }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const items = useSelector(selectedArticles);
  const dataContributor = useSelector(contributorData);
  const dataPayer = useSelector(taxPayerData);
  const contributor = getContribData(dataContributor);
  const payer = getPayerData(dataPayer);

  useEffect(() => {
    dispatch(calTotal());
  }, [items]);

  useEffect(() => {
    dispatch(loadCaptcha(null));
    if (!detail && isChecked(contributor, payer)) {
      history.push(PATH_FORM);
    }
  }, []);

  return (
    <MainLayout>
      <Wrapper>
        <BackButton detail={detail} />
        <Header detail={detail} />
        <Table />
        <Buttons detail={detail} />
      </Wrapper>
    </MainLayout>
  );
};

export default GeneratePaymentRequest;
